import { t } from "i18next";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import React, {
  RefObject,
  useCallback,
  useMemo,
  useRef,
  useState,
} from "react";
import { Outlet } from "react-router-dom";

import { DEFAULT_API_CONFIG } from "../../api/api-config";
import { CustomersTable } from "../../components/customers-table/CustomersTable";
import { MapWrapper } from "../../components/map/MapWrapper";
import { PageLayout } from "../../components/pagelayout/PageLayout";
import { Text } from "../../components/text/Text";
import useDataFetch from "../../hooks/useDataFetch";
import { ICustomer } from "../../utils/data-types";
import "./Customers.scss";

export const Customers = () => {
  const mapContentRef: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
  const [url] = useState<string>(
    DEFAULT_API_CONFIG.url + "/crm/kunde/get4user"
  );
  const [data] = useDataFetch<ICustomer[]>(url, "GET");
  const [selectedId, setSelectedId] = useState<number | undefined>();

  const handleSelectedIdChange = useCallback((id: number | undefined) => {
    setSelectedId(id);
  }, []);

  const features = useMemo(() => {
    const features = [];
    if (data === undefined) return [];
    for (let i = 0; i < data.length; ++i) {
      if (data[i].geom !== null) {
        const jsonOb = JSON.parse("" + data[i].geom);
        const coord = jsonOb.coordinates;
        const feature = new Feature(new Point([coord[0], coord[1]]));
        if (feature) {
          feature.setId(data[i].id);
          const geometry = feature.getGeometry();
          if (geometry) {
            geometry.transform("EPSG:4326", "EPSG:3857");
          }
          features.push(feature);
        }
      }
    }
    return features;
  }, [data]);

  return (
    <PageLayout isCustomersPage title={t("pages.customers.title") as string}>
      <div className="customers__header">
        <Text
          className="customers__header__subtitle"
          text={t("pages.customers.description")}
          size="xxs"
          color="dark-contrast"
        />
      </div>
      <div className="customers__content-container">
        <CustomersTable
          data={data}
          features={features}
          onSelectedIdChange={handleSelectedIdChange}
        />
        <MapWrapper features={features} selectedId={selectedId}>
          <div ref={mapContentRef} className="map-layout--content">
            <Outlet />
          </div>
        </MapWrapper>
      </div>
    </PageLayout>
  );
};
